import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClearanceItemService } from '../clearance-item.service';
import { MaterializeAction } from 'angular2-materialize';
import { NotificationsService, Notification } from '../../shared/helper-components/index'
import { ClearanceItem, MassUpdateData } from '../clearance-item.model';
import { ILookup } from '../../shared/lookup';

@Component({
    selector: 'group-name',
    template: require('./clearance-item-groupname.component.html')
})
export class ClearanceItemGroupNameComponent implements OnInit {

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    projectId: string;
    @Output()
    groupNameUpdated: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    searchResults: ILookup[];
    groupNameForm: FormGroup;
    massUpdateData: MassUpdateData;
    modalActionsGN = new EventEmitter<string | MaterializeAction>();
    modelParams = [
        {
            dismissible: false,
            onOpen: () => { this.setFocus() }
            // complete: this.setFocus()
        }
    ]
    autocompleteInit = {};

    constructor(
        private _fb: FormBuilder,
        private _clearanceItemService: ClearanceItemService,
        private _notificationsService: NotificationsService
    ) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.groupNameForm = this._fb.group(
            {
                reportGroupName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(255)]]
            });

        this.ProcessGroupNameSearch();

    }

    ProcessGroupNameSearch(): void {
        this._clearanceItemService.searchTerm(this.groupNameForm.controls['reportGroupName'].valueChanges, this.projectId, 100, 'reportGroups')
            .subscribe(searchResults => {

                // console.log('searchResults: ' + JSON.stringify(searchResults));
                this.searchResults = searchResults.find(r => r.lookupType == 'reportGroups').lookupData;
                if (searchResults != null && searchResults.length > 0) {

                    var repGroupNames: string = '';

                    for (let rgroup of this.searchResults) {
                        repGroupNames = repGroupNames + '"' + this.escapeDoubleQuotes(rgroup.name) + '": null,';
                    }
                    repGroupNames = repGroupNames.slice(0, -1);
                    repGroupNames = '{' + repGroupNames + '}';
                    //console.log(projNames);
                    var data = JSON.parse(repGroupNames);

                    this.autocompleteInit = {
                        'data': data,
                        onAutocomplete: (val) => {

                        },
                    };
                }
            }
            );
    }

    escapeDoubleQuotes(str: string): string {
        if (!str)
            return '';
        return str.replace(/\\([\s\S])|(")/g, "\\$1$2"); // thanks @slevithan!
    }

    setFocus() {
        console.log('setFocus()');
        $('#groupName').focus();
        $('#groupName').select();
    }


    updateGroupName() {

        if (!this.groupNameForm.valid) {
            this._notificationsService.add(new Notification('warn', 'Please enter a Group Name.', 'Required Field'));
            return;
        }

        this.groupNameUpdated.next(this.groupNameForm);
        this.modalActionsGN.emit({ action: "modal", params: ['close'] });

    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/bulk-action/clearance-item-groupname.component.ts